// import request from "request";
import qs from "qs";
import confing from "./config";
import request from "@/utils/request";
const token = sessionStorage.getItem("token");
var tokens = JSON.parse(token);
// 假设这是你的tokens对象

const headers = {};

if (tokens && tokens.access_token) {
  headers.Authorization = "Bearer " + tokens.access_token; // 注意这里有个空格在"Bearer"和tokens.access_token之间
}

// 现在headers对象可能包含Authorization属性，也可能不包含，取决于tokens对象的状态
// ////console.log(headers);

//登录
export const tok = (params) => {
  const headers = {
    "Content-Type": "application/json",
  };
  return request.post(confing.tok, params, { headers });
};

// 带服务端验证码的账号密码登录
export const captchaLogin = (params) => {
  const headers = {
    "Content-Type": "application/json",
  };
  return request.post(confing.captchaLogin, params, { headers });
};

// 获取并校验滑块验证码
export const getCaptcha = (params) =>
  request.post(confing.captchaGet, params).then((response) => response.data);

export const checkCaptcha = (params) =>
  request.post(confing.captchaCheck, params).then((response) => response.data);

//第三方登录尝试登录方法
export const tryLogin = (params) => {
  const headers = {
    "Content-Type": "application/json",
  };
  return request.post(confing.tryLogin, params, { headers });
};
//登录信息
export const xx = (head) => {
  // location.reload();
  var tokens = JSON.parse(head);
  // 假设这是你的tokens对象

  const headers = {};

  if (tokens && tokens) {
    headers.Authorization = "Bearer " + tokens.accessToken; // 注意这里有个空格在"Bearer"和tokens.access_token之间
  }
  // ////console.log(headers, "546456565");
  return request.get(confing.xx, { headers });
};

// 共享函数：处理 token 和请求头部
const withAuth = (url, method, params) => {
  let tokenUser = sessionStorage.getItem("token");
  if (tokenUser) {
    tokenUser = JSON.parse(tokenUser);
  }
  const tus = tokenUser ? tokenUser.accessToken : null;
  const options = {
    method,
    url,
    headers: tus
      ? { Authorization: "Bearer " + tus, "Content-Type": "application/json" }
      : {},
  };
  if (method.toLowerCase() === "get" && params) {
    options.params = params;
  } else {
    options.data = params;
  }
  return request(options);
};

// 制度分页
export const lation = (params) => {
  // return withAuth(confing.lation, "GET", params);
  return request.get(confing.lation, params);
};
// 首页政策分页
export const lationWeb = (params) => {
  // return withAuth(confing.lation, "GET", params);
  return request.get(confing.lationWeb, params);
};
// 新闻分页
export const news = (params) => {
  // return withAuth(confing.news, "GET", params);
  return request.get(confing.news, params);
};
// 新闻详情
export const newsde = (params) => {
  // return withAuth(confing.newsde, "GET", params);
  return request.get(confing.newsde, params);
};
//点赞新闻
export const dianz = (params) => {
  // ////console.log(tokens.access_token);
  return withAuth(confing.dianz + params, "GET", null);
  // return request.get(confing.dianz + params);
};
//取消点赞
export const qxdianz = (params) => {
  return withAuth(confing.qxdianz + params, "GET", null);
  // return request.get(confing.qxdianz + params);
};
// 仪器分页
export const yiqi = (params) => {
  // return withAuth(confing.yiqi, "GET", params);
  return request.get(confing.yiqi, params);
};
// 仪器详情
export const yiqixq = (params) => {
  // return withAuth(confing.yiqixq, "GET", params);
  return request.get(confing.yiqixq, params);
};
// 仪器分类
export const fenlei = () => {
  return request.get(confing.fenlei);
};
// 仪器学科
export const xueke = (params) => {
  return request.get(confing.xueke + params);
};
//仪器地区
export const diqu = () => {
  return request.get(confing.diqu);
};
//相关仪器
export const xiangguan = (params) => {
  return request.get(confing.xiangguan, params);
};
//注册
export const zhuce = (params) => {
  return request.post(confing.zhuce, params);
};
//获取登录信息
export const denglu = (params) => {
  return withAuth(confing.denglu + params, "GET", null);
  //return request.post(confing.denglu + params);
};
//个人信息
export const user = (params) => {
  return withAuth(confing.user, "POST", params);
  // return request.post(confing.user, params);
};
//修改密码
export const password = (params) => {
  return withAuth(confing.password, "POST", params);
};
//收藏仪器
export const collect = (id, type, uid) => {
  const url = `${confing.collect}&singleId=${id}&collectType=${type}&userId=${uid}`;

  // return withAuth(url, "GET", null);
  return request.get(url);
};
//取消收藏仪器
export const delcollect = (id, type) => {
  const durl = `${confing.delcollect}&singleId=${id}&collectType=${type}`;

  return withAuth(durl, "post", null);
  // return request.post(durl);
};
//批量取消收藏仪器 singleIds
export const delcollectsss = (id, type) => {
  const urls = `${confing.delcollectsss}&singleIds=${id}&collectType=${type}`;

  return withAuth(urls, "post", null);
  // return request.post(urls);
};
//收藏仪器列表
export const selectcollect = (params) => {
  return withAuth(confing.selectcollect, "POST", params);
  // return request.get(confing.selectcollect, params);
};
//创建仪器订单
export const order = (params) => {
  return withAuth(confing.order, "post", params);
  // return request.post(confing.order, params);
};
//仪器订单列表
export const orderpage = (params) => {
  return withAuth(confing.orderpage, "POST", params);
  // return request.get(confing.orderpage, params);
};

export const orderpagestatus = (params) => {
  return withAuth(confing.orderpagestatus, "POST", params);
  // return request.get(confing.orderpagestatus, params);
};
//仪器订单取消
export const orderstatus = (params) => {
  // return withAuth(confing.orderstatus, "GET", params);
  return request.post(confing.orderstatus, params);
};
//仪器订单删除
export const deleteorder = (params) => {
  return withAuth(confing.deleteorder + params, "POST");
  // return request.post(confing.deleteorder + params);
};
//仪器订单查看
export const ordergetone = (params) => {
  return withAuth(confing.ordergetone + params, "GET");
  // return request.get(confing.ordergetone + params);
};
//仪器订单修改
export const orderupdate = (params) => {
  return withAuth(confing.orderupdate, "POST", params);
};
//关注列表
export const guanzulie = (params) => {
  // return withAuth(confing.guanzulie, "GET", params);
  return request.get(confing.guanzulie, params);
};
//数量
export const shuliang = (params) => {
  return withAuth(confing.shuliang, "POST", params);
  // return request.get(confing.shuliang, params);
};
//头像
export const touxiang = (params) => {
  return withAuth(confing.touxiang + params, "POST");
  // return request.post(confing.touxiang);
};
//预约时间列表
export const time = (id, sj) => {
  const urls = `${confing.time}?id=${id}&appointDate=${sj}`;
  // return withAuth(urls, "GET", null);
  return request.get(urls);
};
//刷新
export const shuaxin = (params) => {
  return request.post(confing.shuaxin, params);
};
//用户评价
export const pingjia = (params) => {
  // ////console.log(params);
  // return withAuth(confing.pingjia, "POST", params);
  return request.post(confing.pingjia, params);
};
//资源载体
export const zaiti = (params) => {
  return request.get(confing.zaiti + params);
};
//产地国别
export const guobie = (params) => {
  return request.get(confing.guobie + params);
};
//单位列表
export const danwei = (params) => {
  // return withAuth(confing.danwei, "GET", params);
  return request.get(confing.danwei, params);
};
//关联旧单位
export const jiudw = (params) => {
  return withAuth(confing.jiudw, "POST", params);
  // return request.post(confing.jiudw, params);
};
//创建新单位
export const xindw = (params) => {
  return withAuth(confing.xindw, "POST", params);
  // return request.post(confing.xindw, params);
};
//首页仪器数量
export const shoushu = (params) => {
  return request.get(confing.shoushu, params);
};
//产业领域
export const linyu = (params) => {
  return request.get(confing.linyu, params);
};
//办事大厅
export const bans = (params) => {
  // return withAuth(confing.bans, "GET", params);
  return request.get(confing.bans, params);
};

export const userInfoGet = () => {
  return request.get(confing.userInfo);
};

export const basePathUrl = () => {
  return confing.api;
};
//手机号登录
export const sjdenglu = (params) => {
  const headers = {
    "Content-Type": "application/json",
  };
  return request.post(confing.sjdenglu, params, { headers });
};
// 发送验证码（登录）
export const yzmdenglu = (params) => {
  const headers = {
    "Content-Type": "application/json",
  };
  return request.post(confing.yzmdenglu, params, { headers });
};
//  发送验证码（找回密码）

export const zhaohui = (params) => {
  const headers = {
    "Content-Type": "application/json",
  };
  return request.post(confing.zhaohui, params, { headers });
};
//找回密码验证
export const zhyanz = (params) => {
  const headers = {
    "Content-Type": "application/json",
  };
  return request.post(confing.zhyanz, params, { headers });
};
//点击预约仪器按钮
// export const yuyues = (params) => {
//   // return withAuth(confing.bans, "GET", params);
//   return request.get(confing.yuyues, params);
// };
export const yuyues = (id, userId) => {
  const durl = `${confing.yuyues}&id=${id}&userId=${userId}`;

  return withAuth(durl, "get", null);
};
// 置顶新闻
export const zhiding = (params) => {
  // return withAuth(confing.news, "GET", params);
  return request.get(confing.zhiding, params);
};

export const nriiauth = (params) => {
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
  };
  return request.post(confing.nriiauth, params, { headers });
};

//找回密码验证
export const zucesj = (params) => {
  const headers = {
    "Content-Type": "application/json",
  };
  return request.post(confing.zucesj, params, { headers });
};

// 置顶新闻
export const zxiang = (params) => {
  // return withAuth(confing.news, "GET", params);
  return request.get(confing.zxiang, params);
};
